import { ConfigSettingDto } from '../../model/business/ConfigSettingDto';
import { FontTypeEnum } from 'src/app/model/enums/FontTypeEnum';
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OptionsEnum } from 'src/app/model/enums/OptionsEnum';
import { RelationTypeEnum } from 'src/app/model/enums/RelationTypeEnum';
import { EnumConverterService } from 'src/app/services/EnumConverterService';
import { SessionService } from 'src/app/session-service.service';

@Component({
  selector: 'app-application-policy-holder-two',
  templateUrl: './application-policy-holder-two.component.html',
  styleUrls: ['./application-policy-holder-two.component.css'],
})
export class ApplicationPolicyHolderTwoComponent implements OnInit {
  @Input()
  policyHolderFormGroup: FormGroup;

  yesNoList = this.enumConverterService.toBaseList('OptionsEnum', OptionsEnum);
  relationPolicyHolderToInsuredList = this.enumConverterService.toBaseList(
    'RelationTypeEnum',
    RelationTypeEnum
  );

  OptionsEnum = OptionsEnum;
  RelationTypeEnum = RelationTypeEnum;
  FontTypeEnum = FontTypeEnum;

  constructor(private enumConverterService: EnumConverterService, private sessionService: SessionService) { }

  ngOnInit(): void { }

  get configSettings(): ConfigSettingDto {
    return this.sessionService.getConfigSettingsDto();
  }
}
